@if (loadStatus() === 'failed') {
  <glxy-alert
    class="knowledge-bases-error"
    type="error"
    [showAction]="true"
    actionTitle="{{ 'COMMON.RETRY' | translate }}"
    (actionClick)="initialize()"
  >
    {{ 'KNOWLEDGE_COLLECTIONS.ERROR_LOADING' | translate }}
  </glxy-alert>
} @else if (loadStatus() === 'loading') {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else {
  @if (selectedKnowledgeBases().length > 0) {
    <mat-list class="knowledge-bases-list">
      @for (kb of selectedKnowledgeBases(); track kb.id) {
        <mat-list-item class="knowledge-bases-list__item">
          <mat-icon matListItemIcon class="knowledge-bases-list__icon">library_books</mat-icon>
          @if (detailRouteFor(kb); as detailRoute) {
            <a matListItemTitle class="knowledge-bases-list__name-link" [routerLink]="detailRoute">{{ kb.name }}</a>
          } @else {
            <div matListItemTitle>{{ kb.name }}</div>
          }
          @if (kb.description) {
            <div matListItemLine class="knowledge-bases-list__preview">{{ kb.description }}</div>
          }
          @if (enabled()) {
            <div matListItemMeta>
              <div>
                <mat-icon
                  class="clickable"
                  role="button"
                  [attr.aria-label]="'KNOWLEDGE_COLLECTIONS.REMOVE' | translate"
                  (click)="removeKnowledgeBase(kb)"
                  >close</mat-icon
                >
              </div>
            </div>
          }
        </mat-list-item>
      }
    </mat-list>
  } @else {
    <p class="knowledge-bases-empty">{{ 'KNOWLEDGE_COLLECTIONS.EMPTY' | translate }}</p>
  }

  @if (enabled()) {
    <glxy-form-field class="knowledge-bases-select">
      <input
        #knowledgeBaseInput
        matInput
        #trigger="matAutocompleteTrigger"
        placeholder="{{ 'KNOWLEDGE_COLLECTIONS.CONNECT' | translate }}"
        [formControl]="selectControl"
        autocomplete="off"
        (keydown.enter)="chooseMatch($event)"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addKnowledgeBase($event.option.value)">
        @if (filteredKnowledgeBases().length === 0) {
          <mat-option disabled class="knowledge-base-option">
            {{ 'KNOWLEDGE_COLLECTIONS.NONE_AVAILABLE' | translate }}
          </mat-option>
        }
        @for (kb of filteredKnowledgeBases(); track kb.id) {
          <mat-option [value]="kb" class="knowledge-base-option">
            <mat-icon class="knowledge-base-option__icon">library_books</mat-icon>
            <div matLine>{{ kb.name }}</div>
            @if (kb.description) {
              <div matLine class="knowledge-base-option__preview">{{ kb.description }}</div>
            }
          </mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
  }
}
